import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { ElementDetailsResource } from "models/Resources/ElementDetailsResource";

const initialState = {
  details: [],
  actions: [],
} satisfies ElementDetailsResource as ElementDetailsResource;

export const elementDetailsSlice = createSlice({
  name: "elementDetails",
  initialState,
  reducers: {
    resetElementDetails: state => {
      state.details = [];
      state.actions = [];
    },

    setElementDetails(state, action: PayloadAction<ElementDetailsResource>) {
      state.actions = action.payload.actions;
      state.details = action.payload.details;
    },
  },
});

export const { resetElementDetails, setElementDetails } =
  elementDetailsSlice.actions;
export default elementDetailsSlice.reducer;
